// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var RescriptRelay_Internal = require("rescript-relay/src/RescriptRelay_Internal.bs.js");

var Types = {};

function unwrap_response_updateUserNotificationSettingsV5(__x) {
  return RescriptRelay_Internal.unwrapUnion(__x, ["UserNotificationSettingsWasUpdated"]);
}

var variablesConverter = {"updateUserNotificationSettingsV5Input":{},"__root":{"input":{"r":"updateUserNotificationSettingsV5Input"}}};

function convertVariables(v) {
  return RescriptRelay.convertObj(v, variablesConverter, undefined, undefined);
}

var wrapResponseConverter = {"__root":{"updateUserNotificationSettingsV5_UserNotificationSettingsWasUpdated_updatedUserNotificationSettings":{"f":""},"updateUserNotificationSettingsV5":{"u":"response_updateUserNotificationSettingsV5"}}};

var wrapResponseConverterMap = {
  response_updateUserNotificationSettingsV5: RescriptRelay_Internal.wrapUnion
};

function convertWrapResponse(v) {
  return RescriptRelay.convertObj(v, wrapResponseConverter, wrapResponseConverterMap, null);
}

var responseConverter = {"__root":{"updateUserNotificationSettingsV5_UserNotificationSettingsWasUpdated_updatedUserNotificationSettings":{"f":""},"updateUserNotificationSettingsV5":{"u":"response_updateUserNotificationSettingsV5"}}};

var responseConverterMap = {
  response_updateUserNotificationSettingsV5: unwrap_response_updateUserNotificationSettingsV5
};

function convertResponse(v) {
  return RescriptRelay.convertObj(v, responseConverter, responseConverterMap, undefined);
}

var Internal = {
  variablesConverter: variablesConverter,
  variablesConverterMap: undefined,
  convertVariables: convertVariables,
  wrapResponseConverter: wrapResponseConverter,
  wrapResponseConverterMap: wrapResponseConverterMap,
  convertWrapResponse: convertWrapResponse,
  responseConverter: responseConverter,
  responseConverterMap: responseConverterMap,
  convertResponse: convertResponse,
  convertWrapRawResponse: convertWrapResponse,
  convertRawResponse: convertResponse
};

function broadcastMessageNotificationPreferenceSettingV5_decode($$enum) {
  if ($$enum === "ALL_CATEGORIES" || $$enum === "NO_CATEGORIES") {
    return $$enum;
  }
  
}

function broadcastMessageNotificationPreferenceSettingV5_fromString(str) {
  return broadcastMessageNotificationPreferenceSettingV5_decode(str);
}

function entityNotificationPreferenceSettingV5_decode($$enum) {
  if ($$enum === "CUSTOM" || $$enum === "CHAPTER_DEFAULT" || $$enum === "MATCH_ONLY") {
    return $$enum;
  }
  
}

function entityNotificationPreferenceSettingV5_fromString(str) {
  return entityNotificationPreferenceSettingV5_decode(str);
}

var Utils = {
  broadcastMessageNotificationPreferenceSettingV5_decode: broadcastMessageNotificationPreferenceSettingV5_decode,
  broadcastMessageNotificationPreferenceSettingV5_fromString: broadcastMessageNotificationPreferenceSettingV5_fromString,
  entityNotificationPreferenceSettingV5_decode: entityNotificationPreferenceSettingV5_decode,
  entityNotificationPreferenceSettingV5_fromString: entityNotificationPreferenceSettingV5_fromString
};

var node = ((function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "usedFor",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v6 = {
  "alias": "type_",
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "nodeId",
  "storageKey": null
},
v8 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "userHasInactiveCustomPreference",
    "storageKey": null
  }
],
v9 = {
  "alias": null,
  "args": null,
  "concreteType": "Area",
  "kind": "LinkedField",
  "name": "areas",
  "plural": true,
  "selections": [
    (v6/*: any*/)
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "NotificationSettingsBuyerNeeds_UpdateUserNotificationSettingsV5Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateUserNotificationSettingsV5",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNotificationSettingsV5",
                "kind": "LinkedField",
                "name": "updatedUserNotificationSettings",
                "plural": false,
                "selections": [
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "NotificationSettingsBuyerNeeds_notificationSetting"
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "UserNotificationSettingsWasUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "NotificationSettingsBuyerNeeds_UpdateUserNotificationSettingsV5Mutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "updateUserNotificationSettingsV5",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNotificationSettingsV5",
                "kind": "LinkedField",
                "name": "updatedUserNotificationSettings",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "UserAreaGroup",
                    "kind": "LinkedField",
                    "name": "userAreaGroups",
                    "plural": true,
                    "selections": [
                      (v3/*: any*/),
                      (v4/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Area",
                        "kind": "LinkedField",
                        "name": "areas",
                        "plural": true,
                        "selections": [
                          (v3/*: any*/),
                          (v5/*: any*/),
                          (v6/*: any*/),
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "buyerNeeds",
                    "plural": false,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v8/*: any*/),
                        "type": "ChapterDefaultNotificationSetting",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v8/*: any*/),
                        "type": "MatchesOnlyNotificationSetting",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "maxPrice",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "minPrice",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "propertyTypes",
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": null,
                            "kind": "LinkedField",
                            "name": "areaGroup",
                            "plural": false,
                            "selections": [
                              (v2/*: any*/),
                              {
                                "kind": "TypeDiscriminator",
                                "abstractKey": "__isAreaGroupV5"
                              },
                              (v3/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Area",
                                "kind": "LinkedField",
                                "name": "areas",
                                "plural": true,
                                "selections": [
                                  (v3/*: any*/),
                                  (v5/*: any*/),
                                  (v7/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v4/*: any*/),
                                  (v9/*: any*/)
                                ],
                                "type": "UserAreaGroup",
                                "abstractKey": null
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v9/*: any*/)
                                ],
                                "type": "ChapterAreaGroup",
                                "abstractKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "type": "CustomClientNeedNotificationPreference",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "type": "UserNotificationSettingsWasUpdated",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d0da67f8eececde1dfa301edee4fe29f",
    "id": null,
    "metadata": {},
    "name": "NotificationSettingsBuyerNeeds_UpdateUserNotificationSettingsV5Mutation",
    "operationKind": "mutation",
    "text": "mutation NotificationSettingsBuyerNeeds_UpdateUserNotificationSettingsV5Mutation(\n  $input: UpdateUserNotificationSettingsV5Input!\n) {\n  updateUserNotificationSettingsV5(input: $input) {\n    __typename\n    ... on UserNotificationSettingsWasUpdated {\n      updatedUserNotificationSettings {\n        ...NotificationSettingsBuyerNeeds_notificationSetting\n        nodeId\n      }\n    }\n  }\n}\n\nfragment NotificationSettingsBuyerNeeds_notificationSetting on UserNotificationSettingsV5 {\n  ...NotificationSettingsPreferenceEditDialog_settings\n  buyerNeeds {\n    __typename\n    ... on ChapterDefaultNotificationSetting {\n      userHasInactiveCustomPreference\n    }\n    ... on MatchesOnlyNotificationSetting {\n      userHasInactiveCustomPreference\n    }\n    ... on CustomClientNeedNotificationPreference {\n      maxPrice\n      minPrice\n      propertyTypes\n      areaGroup {\n        __typename\n        ...NotificationSettingsComponents_group\n      }\n      ...NotificationSettingsPreferenceEditDialog_clientNeed\n    }\n  }\n}\n\nfragment NotificationSettingsComponents_byType on AreaGroupV5 {\n  __isAreaGroupV5: __typename\n  __typename\n  ... on UserAreaGroup {\n    __typename\n  }\n  ... on ChapterAreaGroup {\n    __typename\n  }\n}\n\nfragment NotificationSettingsComponents_group on AreaGroupV5 {\n  __isAreaGroupV5: __typename\n  __typename\n  id\n  areas {\n    id\n    label\n    nodeId\n  }\n  ... on UserAreaGroup {\n    usedFor\n  }\n  ...NotificationSettingsComponents_byType\n}\n\nfragment NotificationSettingsPreferenceEditDialogAreaGroups_settings on UserNotificationSettingsV5 {\n  userAreaGroups {\n    id\n    usedFor\n    areas {\n      id\n      label\n      type_: type\n      nodeId\n    }\n  }\n}\n\nfragment NotificationSettingsPreferenceEditDialog_areaGroup on AreaGroupV5 {\n  __isAreaGroupV5: __typename\n  __typename\n  ... on ChapterAreaGroup {\n    id\n    areas {\n      label\n      id\n      type_: type\n      nodeId\n    }\n  }\n  ... on UserAreaGroup {\n    id\n    areas {\n      id\n      label\n      type_: type\n      nodeId\n    }\n    usedFor\n  }\n}\n\nfragment NotificationSettingsPreferenceEditDialog_clientNeed on CustomClientNeedNotificationPreference {\n  maxPrice\n  minPrice\n  propertyTypes\n  areaGroup {\n    __typename\n    ...NotificationSettingsPreferenceEditDialog_areaGroup\n  }\n}\n\nfragment NotificationSettingsPreferenceEditDialog_settings on UserNotificationSettingsV5 {\n  ...NotificationSettingsPreferenceEditDialogAreaGroups_settings\n}\n"
  }
};
})());

var wrap_response_updateUserNotificationSettingsV5 = RescriptRelay_Internal.wrapUnion;

exports.Types = Types;
exports.unwrap_response_updateUserNotificationSettingsV5 = unwrap_response_updateUserNotificationSettingsV5;
exports.wrap_response_updateUserNotificationSettingsV5 = wrap_response_updateUserNotificationSettingsV5;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* node Not a pure module */
